import React, { Component } from "react";
import UserContext from "./UserContext";
import {
  auth,
  updateUserStatus,
  addLoginAnalytics,
  addDisconnectListener,
  getUserDetails,
} from "../../firebase/firebase";

class UserProvider extends Component {
  state = {
    user: null,
  };
  componentDidMount = async () => {
    auth.onAuthStateChanged(async (userAuth) => {
      if (userAuth) {
        // console.log(userAuth.email, userAuth.photoURL);
        this.setState({
          user: userAuth,
        });

        let Id = userAuth.email;
        Id = Id.replace(/[&\/\\#,+$~%.'":*?<>{}]/g, "");
        Id = Id.toLowerCase();

        await updateUserStatus(Id);
        // window.userData = await getUserDetails(userAuth.email);
        window.userData = {
          email: userAuth.email,
          name: userAuth.displayName
            ? userAuth.displayName
            : userAuth.email.split("@")[0],
        };
        await addLoginAnalytics(userAuth);
        window.app.appConfig(userAuth);
        addDisconnectListener(userAuth);
        // var elem = document.body;

        // if (elem.requestFullscreen) {
        //   elem.requestFullscreen();
        // } else if (elem.webkitRequestFullscreen) {
        //   /* Safari */
        //   elem.webkitRequestFullscreen();
        // } else if (elem.msRequestFullscreen) {
        //   /* IE11 */
        //   elem.msRequestFullscreen();
        // }
      } else {
        localStorage.clear();
        sessionStorage.clear();
        window.userData = null;
        this.setState({
          user: null,
        });
      }
    });
  };
  render() {
    const { user } = this.state;

    return (
      <UserContext.Provider value={user}>
        {this.props.children}
      </UserContext.Provider>
    );
  }
}

export default UserProvider;
